import React, { useCallback, useContext, useEffect } from 'react'
import Head from 'next/head'
import { isDuApp } from '@/utils/appUtils/getDevice'
import Jockeys, { ShareOptionType } from '@/utils/jockey'
import customNavContext from '@/context/customNavContext'

interface IShare {
  title: string
  description: string
  link: string
  imgUrl: string
}

interface IProps {
  propsConfig: IShare
  editConfig: {
    local: string
    lang: string
  }
}

const defaultProps = {
  title: 'POIZON買家購買上線啦，快來領取百元大禮包！',
  description: 'POIZON買家版為您提供全新的潮物購買體驗，新用戶可享百元優惠，快來參與吧 >>',
  link: '',
  imgUrl: 'https://cdn.poizon.com/node-common/ec78ceb0c9b3d667deb9292531214b70.png',
}

function Share(props: IProps) {
  const { hideNavigation } = useContext(customNavContext)
  const propsConfig = props.propsConfig || defaultProps
  const {
    title = '賣家大召集！POIZON年尾重磅福利來襲！',
    description = '全場費率勁減最低至3%！快嚟賣野啦>>>',
    link,
    imgUrl = 'https://cdn.poizon.com/node-common/d12eb0087f5ec9ccb00b4ee6d6c97a9d.jpg',
  } = propsConfig
  const setRightBtn = useCallback(() => {
    // 非自定义滚动条
    if (isDuApp() && hideNavigation === 0 || !hideNavigation) {
      console.error('hideNavigation.....')
      const option: ShareOptionType = {
        title,
        description,
        link: link || (typeof window !== 'undefined' ? location.href : ''),
        imgUrl,
      }
      Jockeys.rightBarButtonItem(option)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    setRightBtn()
  }, [setRightBtn])

  if (hideNavigation === 1) {
    return null
  }

  return (
    <Head>
      <meta property="og:type" content="website" key="type" />
      <meta property="og:title" content={title} key="title" />
      <meta property="og:description" content={description} key="description" />
      <meta property="og:image" content={imgUrl} key="image" />
      <meta property="description" content={description} key="doc-description" />
    </Head>
  )
}

Share.config = {
  name: 'poizon-share',
}

export default Share
